<template>
    <div id="app">
        <div class="app-aura app-aura-left"></div>
        <div class="app-aura app-aura-right"></div>

        <main class="app-main">
            <router-view/>
        </main>

        <div class="footer-nav">
            <div class="nav-item" :class="{ active: $route.name === 'Home' }" @click="goPage('/')">
                <van-icon name="home-o" />
                <span>首页</span>
            </div>
            <div class="nav-item" :class="{ active: $route.name === 'video' || $route.name === 'videoPlay' }" @click="goPage('/video')">
                <van-icon name="play-circle-o" />
                <span>视频</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goPage(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="less">
:root {
    --a-bg: #030712;
    --a-surface: rgba(15, 23, 42, 0.9);
    --a-primary: #8b5cf6;
    --a-secondary: #22d3ee;
    --a-text: #f8fafc;
    --a-muted: #94a3b8;
    --a-shadow: 0 20px 40px rgba(2, 6, 23, 0.55);
    --a-radius: 1.2rem;
}

* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    font-family: "Trebuchet MS", "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 1.5rem;
    color: var(--a-text);
    background:
        radial-gradient(circle at 8% 6%, rgba(139, 92, 246, 0.28) 0, transparent 32%),
        radial-gradient(circle at 90% 2%, rgba(34, 211, 238, 0.22) 0, transparent 28%),
        linear-gradient(140deg, #020617 0%, #060b1f 45%, #111827 100%);
}

html,
body {
    height: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

a {
    text-decoration: none;
}

img {
    border: 0;
    vertical-align: middle;
}

em,
i {
    font-style: normal;
}

li {
    list-style: none;
}

button {
    cursor: pointer;
}

@media screen and (min-width: 320px) {
    html {
        font-size: 65% !important;
    }
}

@media screen and (min-width: 750px) {
    html {
        font-size: 100% !important;
    }
}

#app {
    position: relative;
    width: 100%;
    max-width: 750px;
    min-height: 100vh;
    margin: 0 auto;
    padding: .55rem .55rem 6.2rem;
    overflow: hidden;
}

.app-aura {
    position: absolute;
    border-radius: 50%;
    filter: blur(8px);
    z-index: 0;
    pointer-events: none;
    opacity: .75;
}

.app-aura-left {
    width: 11rem;
    height: 11rem;
    left: -3rem;
    top: 4rem;
    background: rgba(139, 92, 246, 0.28);
}

.app-aura-right {
    width: 12.5rem;
    height: 12.5rem;
    right: -3.5rem;
    top: 12rem;
    background: rgba(34, 211, 238, 0.22);
}

.app-main {
    position: relative;
    z-index: 1;
}

.footer-nav {
    position: fixed;
    left: 50%;
    bottom: .6rem;
    transform: translateX(-50%);
    width: auto;
    display: flex;
    gap: .5rem;
    padding: .25rem;
    border-radius: 999px;
    background: rgba(2, 6, 23, 0.86);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 12px 30px rgba(2, 6, 23, 0.65);
    z-index: 999;

    .nav-item {
        min-width: 7.2rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: .35rem;
        text-align: center;
        padding: .62rem .85rem;
        border: 1px solid rgba(255, 255, 255, 0.06);
        background: rgba(15, 23, 42, 0.8);
        color: #cbd5e1;
        font-size: .88rem;
        border-radius: 999px;
        transition: all .25s ease;

        .van-icon {
            font-size: 1.05rem;
            line-height: 1;
        }

        &.active {
            background: linear-gradient(130deg, var(--a-primary), var(--a-secondary));
            color: #020617;
            font-weight: 800;
            border-color: transparent;
            box-shadow: 0 10px 24px rgba(34, 211, 238, 0.16);
        }
    }
}
</style>